<template>
    <transition name="el-fade-in-linear">
        <div v-if="showComment">
            <div class="comment v-comment-wrapper" @mouseover="seen"
                 :id="'comment' + list.id" :class="highlightClass">

                <div class="content" v-if="(list.is_removed || list.is_deleted) && !isHumtogAdministrator" style="background: #eeeeee">
                    <div class="text" style="padding-left: 1rem">
                        {{ list.content.text }}
                    </div>
                </div>

                <div class="content" v-else
                     :style="{background: (isHumtogAdministrator && (deleted || list.is_removed)) ? '#eec6c6' : ''}">

                    <div class="v-comment-info">
                        <div class="display-flex">
                            <div class="left">
                                <div v-if="showCommentHeader">
                                    <router-link :to="'/' + '@' + list.author.username"
                                                 class="avatar user-select">
                                        <img v-bind:src="list.author.avatar"/>
                                    </router-link>

                                    <router-link :to="'/' + '@' + list.author.username"
                                                 class="authorname">
                                        {{ list.author.name }}
                                    </router-link>

                                    <router-link :to="'/' + '@' + list.author.username"
                                                 class="author user-select">
                                        @{{ list.author.username }}
                                    </router-link>
                                    <el-tooltip
                                            :content="'Edited: ' + editedDate"
                                            placement="top"
                                            transition="false"
                                            :open-delay="500"
                                            v-if="isEdited"
                                    >
                                        <span class="edited go-gray">Edited</span>
                                    </el-tooltip>

                                    <span class="separator" v-if="isEdited">&#183;</span>

                                    <el-tooltip
                                            :content="'Created: ' + longDate"
                                            placement="top"
                                            transition="false"
                                            :open-delay="500"
                                    >
                                        <a class="date margin-left-1" @click.prevent="openOrigin">{{ date }}</a>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="actionType === 'edit' && currentCommentId === list.id">
                        <comment-form v-if="currentCommentId === list.id" :submission="list.submission_id"
                                      :type="activeComment.type" :commentors="commentors"
                                      :currentCommentId="currentCommentId" :activeComment="activeComment"
                                      :actionType="actionType" :key="actionType + currentCommentId">
                        </comment-form>
                    </div>
                    <div v-else class="text">
                        <markdown v-if="showCommentText" :text="list.content.text"></markdown>
                        <h4>{{deleted}}</h4>
                        <p v-if="isHumtogAdministrator"> {{list.reason_remove}}</p>

                        <div class="v-comment-info" v-if="! !!deleted || isHumtogAdministrator">
                            <div class="display-flex">
                                <div class="left">
                                    <el-tooltip content="Submission" placement="top"
                                                transition="false" :open-delay="500">
                                        <a class="reply margin-left-1" v-if="!full" @click.prevent="openOrigin">
                                            <i class="v-icon v-link h-purple"></i>
                                        </a>
                                    </el-tooltip>

                                    <div v-if="isLoggedIn" @click="vote(1)"
                                         :class="list.uservote > 0 ? 'upvotedon animated fadeIn' : 'upvotedoff fadeOut'"
                                         class="htudvm">
                                        <span v-if="list.uservote > 0" class="htuv"
                                              size="small">Upvoted</span>
                                        <span v-else class="htuv"
                                            size="small">Upvote</span>
                                        <span>|</span>
                                        <span type="primary" class="htudvc">{{ list.votes }}</span>
                                    </div>                                    

                                    <div v-else @click="loginIn"
                                         class="htudvm">
                                        <span class="htuv" size="small"><span>Upvote</span></span>
                                        <span>|</span>
                                        <span type="primary" class="htudvc">{{ list.votes }}</span>
                                    </div>

                                    <div v-if="isLoggedIn" @click="vote(-1)"
                                          class="dbtm" size="small">
                                        <span v-if="list.uservote < 0">Downvoted</span>
                                        <span v-else>Downvote</span>
                                    </div>

                                    <span v-else class="dbtm" size="small"
                                          @click="loginIn">Downvote</span>

                                    <el-tooltip content="Reply" placement="top"
                                                transition="false" :open-delay="500">
                                        <a class="replycomment" @click="commentReply"
                                           v-if="list.nested_level < 10 && full">Reply</a>
                                    </el-tooltip>

                                    <el-button v-if="owns && full" size="mini" class="margin-left-1"
                                               @click="edit" round>
                                        Edit
                                    </el-button>

                                    <el-tooltip :content="'Edited: ' + editedDate" placement="top"
                                                transition="false" :open-delay="500" v-if="isEdited">
                                        <span class="edited go-gray">Edited</span>
                                    </el-tooltip>

                                    <span class="separator" v-if="isEdited">&#183;</span>

                                    <el-tooltip :content="bookmarked ? 'Unbookmark' : 'Bookmark'"
                                                placement="top" transition="false" :open-delay="500">
                                        <i class="v-icon margin-left-1"
                                           :class="{ 'go-yellow v-unbookmark': bookmarked, 'v-bookmark': !bookmarked }"
                                           @click="bookmark"></i>
                                    </el-tooltip>

                                    <span v-if="isHumtogAdministrator" class="dbtm"
                                          size="small" @click="changeType">Change type</span>

                                    <el-dropdown size="mini" type="primary" trigger="click"
                                                 :show-timeout="0" :hide-timeout="0">
                                        <i class="el-icon-more-outline"></i>

                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-if="!owns" @click.native="report">
                                                Report
                                            </el-dropdown-item>

                                            <el-dropdown-item v-if="owns && !deleted"
                                                              class="go-red" @click.native="destroy">
                                                Delete
                                            </el-dropdown-item>

                                            <el-dropdown-item class="go-green" @click.native="approve"
                                                              v-if="showApprove" divided>
                                                Approve
                                            </el-dropdown-item>

                                            <el-dropdown-item v-if="showDisapprove"
                                                              class="go-red" @click.native="disapprove">
                                                Disapprove
                                            </el-dropdown-item>


                                            <el-dropdown-item v-if="deleted && isHumtogAdministrator" class="go-green"
                                                              @click.native="approve" divided>
                                                Re-approve
                                            </el-dropdown-item>

                                            <el-dropdown-item v-if="deleted" class="go-green">
                                                Deleted
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>

                        </div>
                        <div v-if="showTextareaRemoveComment">
                            <textarea v-model="reasonRemoveText" id="textarea-remove-comment"></textarea>
                            <button v-if="reasonRemoveText" class="submit-btn" @click.prevent="disapprove"><b>Save</b>
                            </button>
                        </div>
                    </div>
                </div>

                <comment-form v-if="currentCommentId === list.id && actionType !== 'edit'" :submission="list.submission_id"
                              :type="activeComment.type" :commentors="commentors"
                              :currentCommentId="currentCommentId" :activeComment="activeComment"
                              :actionType="actionType" :key="actionType + currentCommentId">
                </comment-form>

                <div class="comments" v-if="list.children.length">
                    <comment :list="c" v-for="c in sortedComments" :key="c.id"
                             :full="full" :currentCommentId="currentCommentId"
                             :activeComment="activeComment" :actionType="actionType">
                    </comment>
                </div>

                <el-button type="text" v-if="hasMoreCommentsToLoad" @click="loadMoreComments">
                    Load More Comments ({{ list.children.length - childrenLimit }} more replies)
                </el-button>

                <slot name="data"></slot>
            </div>
        </div>
    </transition>
</template>


<script>
    import Markdown from "../components/Markdown.vue";
    import Helpers from "../mixins/Helpers";
    import CommentForm from "./CommentForm";

    export default {
        name: "comment",

        props: ["list", "comments-order", "full", 'commentors', 'currentCommentId', 'activeComment', 'actionType'],

        components: {
            CommentForm,
            Markdown
        },

        mixins: [Helpers],

        data() {
            return {
                editing: false,
                body: this.list.content.text,
                visible: true,
                reply: false,
                childrenLimit: 4,
                highlighted: false,
                deleted: '',
                ownDownVoted: false,
                ownUnVoted: false,
                voteStatus: 0,
                reasonRemoveText: '',
                showTextareaRemoveComment: false
            };
        },

        created() {
            if (_.isUndefined(this.list.children)) {
                this.list.children = [];
            }

            this.$eventHub.$on("newComment", this.newComment);
            this.$eventHub.$on("patchedComment", this.patchedComment);
            this.$eventHub.$on("deletedComment", this.deletedComment);

            // this.visible = ! !!this.list.deleted_at

            this.isDeleted(this.list)
        },

        beforeDestroy() {
            this.$eventHub.$off("newComment", this.newComment);
            this.$eventHub.$off("patchedComment", this.patchedComment);
            this.$eventHub.$off("deletedComment", this.deletedComment);
        },

        mounted() {
            this.$nextTick(function () {
                this.setHighlighted();
                this.scrollToComment();
            });

            this.imgBehavior()
            this.initZoom('#serious #comment' + this.list.id + ' .image img')

        },

        updated(){
            this.imgBehavior()
            this.initZoom('#serious #comment' + this.list.id + ' .image img')

        },

        computed: {
            showComment() {
                if (this.isHumtogAdministrator) {
                    return true
                }
                if (this.owns) {
                    if (this.list.deleted_at && !this.list.deletedAdmin){
                        return false
                    }
                   return true
                }
                if (!!this.deleted) {
                    let children = this.list.children.filter(l => !l.deleted_at)
                    if (!children.length) {
                        return false
                    }
                }

                return true
            },
            showCommentHeader() {
                if (this.isHumtogAdministrator) {
                    return true
                }
                if (this.owns) {
                    if (this.list.deleted_at && !this.list.deletedAdmin){
                        return false
                    }
                   return true
                }                
                return !!!this.list.deleted_at;
            },

            showCommentText() {
                if (this.isHumtogAdministrator) {
                    return true
                }
                if (this.owns) {
                    if (this.list.deleted_at && !this.list.deletedAdmin){
                        return false
                    }
                   return true
                }
                return !!!this.list.deleted_at;
            },

            url() {
            },

            bookmarked: {
                get() {
                    return Store.state.bookmarks.comments.indexOf(this.list.id) !== -1 ? true : false;
                },

                set() {
                    if (Store.state.bookmarks.comments.indexOf(this.list.id) !== -1) {
                        let index = Store.state.bookmarks.comments.indexOf(this.list.id);
                        Store.state.bookmarks.comments.splice(index, 1);

                        return;
                    }

                    Store.state.bookmarks.comments.push(this.list.id);
                }
            },

            isParent() {
                return this.list.parent_id == null ? true : false;
            },

            highlightClass() {
                if (this.highlighted && !this.isParent) {
                    return "child-broadcasted-comment";
                }

                if (this.highlighted && this.isParent) {
                    return "broadcasted-comment";
                }

                return "";
            },

            isEdited() {
                return this.list.edited_at;
            },

            editedDate() {
                return this.parseFullDate(this.list.edited_at);
            },

            points() {
                return this.list.likes_count;
            },

            /**
             * Does the auth user own the submission
             *
             * @return Boolean
             */
            owns() {
                return auth.id == this.list.user_id;
            },

            /**
             * is there more children to load
             *
             * @return bool
             */
            hasMoreCommentsToLoad() {
                return this.list.children.length > this.childrenLimit;
            },

            /**
             * The sorted version of comments
             *
             * @return {Array} comments
             */
            sortedComments() {
                return _.orderBy(this.uniqueList, this.commentsOrder, "desc").slice(
                    0,
                    this.childrenLimit
                );
            },

            /**
             * Due to the issue with duplicate notifiactions (cuz the present ones have diffrent
             * timestamps) we need a different approch to make sure the list is always unique.
             * This ugly coded methods does it! Maybe move this to the Helpers.js mixin?!
             *
             * @return object
             */
            uniqueList() {
                let unique = [];
                let temp = [];

                this.list.children.forEach(function (element, index, self) {
                    if (temp.indexOf(element.id) === -1) {
                        unique.push(element);
                        temp.push(element.id);
                    }
                });

                return unique;
            },

            date() {
                return moment(this.list.created_at)
                    .utc(moment().format("Z"))
                    .fromNow(true);
            },

            /**
             * Calculates the long date to display for hover over date.
             *
             * @return String
             */
            longDate() {
                return this.parseFullDate(this.list.created_at);
            },

            /**
             * whether or not the approve button shoud be displayed
             *
             * @return boolean
             */
            showApprove() {
                let report = !this.list.is_approved;

                return (Store.state.moderatingAt.indexOf(this.list.channel_id) != -1 ||
                    meta.isHumtogAdministrator) && report && !this.owns
            },

            /**
             * whether or not the disapprove button shoud be displayed
             *
             * @return boolean
             */
            showDisapprove() {
                let report = !this.list.is_removed;

                return (Store.state.moderatingAt.indexOf(this.list.channel_id) != -1 ||
                    meta.isHumtogAdministrator) && report && !this.owns
            }
        },

        methods: {
            imgBehavior() {
                let imgs = null;
                if (this.list.type != 'serious') {
                    imgs = document.querySelectorAll('#relaxed #comment' + this.list.id + ' .image img')
                    imgs.forEach(img => {
                        if (img.style.display != 'none') {
                            img.style.display = 'none';
                            let parent = img.parentNode;
                            let newEl = document.createElement('a');
                            newEl.innerHTML = 'image';
                            parent.append(newEl);
                            newEl.addEventListener("click", () => {
                                let image = img.src
                                this.getZoom(image)
                            });
                        }
                    });
                }
            },
            loginIn() {
                this.mustBeLogin();

                // app.$message({
                //     message: "Oops, You Need To Login FIrst.",
                //     type: "error",
                //     showClose: true
                // });
            },

            vote: _.debounce(function(status) {
                if(status === this.list.uservote){
                    this.status = 0;
                } else {
                    this.status = status;
                }

                axios.post("/comment/"+this.list.id+"/vote", { status: this.status })
                    .then(response => {
                        this.list.uservote = response.data.data.uservote;
                        this.list.votes = response.data.data.votes;
                    })
            }, 50),

            upvote(id, status) {
                if (!!this.auth.id) {
                    this.triggerVote(this)
                    if (this.voteStatus <= 0) {
                        this.voteStatus = 1;
                    } else {
                        this.voteStatus = 0;
                    }
                } else {
                    this.mustBeLogin()
                }
            },
            downvote(id, status) {
                if (!!this.auth.id) {
                    this.triggerVote(this)
                    if (this.voteStatus >= 0) {
                        this.voteStatus = -1
                    } else {
                        this.voteStatus = 0
                    }
                } else {
                    this.mustBeLogin()
                }
            },


            openOrigin() {
                app.$Progress.start();

                axios
                    .get(`/submissions/${this.list.submission_id}`)
                    .then(response => {
                        this.$router.push(this.submissionUrl(response.data.data));

                        app.$Progress.finish();
                    })
                    .catch(error => {
                        app.$Progress.fail();
                    });
            },

            /**
             * Sets the initial values for whether or not highlight the comment.
             *
             * @return void
             */
            setHighlighted() {
                if (
                    this.list.broadcasted == true ||
                    this.$route.query.comment == this.list.id
                ) {
                    this.highlighted = true;
                }
            },

            /**
             * Scrolls the page to the comment
             *
             * @return void
             */
            scrollToComment() {
                if (this.$route.query.comment == this.list.id) {
                    document.getElementById("comment" + this.list.id).scrollIntoView();
                }
            },

            /**
             * renders more comments
             *
             * @return void
             */
            loadMoreComments() {
                this.childrenLimit += 4;
            },

            /**
             * seen the comment
             *
             * @return void
             */
            seen() {
                this.highlighted = false;
            },

            /**
             * Send record to be fetched by CommentForm.
             *
             * @return void
             */
            edit() {
                this.editing = !this.editing;
                this.$eventHub.$emit("edit-comment", this.list);
            },

            newComment(comment) {
                if (comment.parent_id == null) return;
                if (this.list.id != comment.parent_id) return;

                // owns the comment
                if (comment.author.id == auth.id) {
                    this.reply = false;
                 //   Store.state.comments.likes.push(comment.id);
                    this.list.children.unshift(comment);

                    // this.$nextTick(function() {
                    //   document.getElementById("comment" + comment.id).scrollIntoView();
                    // });

                    return;
                }

                // add broadcasted (used for styling)
                comment.broadcasted = true;

                this.list.children.unshift(comment);
            },

            /**
             * patches the broadcasted comment.
             *
             * @return void
             */
            patchedComment(comment) {
                if (this.list.id != comment.id) return;

                this.editing = false;
                this.list.content.text = comment.content.text;
                this.list.edited_at = this.now();
            },

            /**
             *  Report(and block) comment
             */
            report() {
                if (this.isGuest) {
                    this.mustBeLogin();
                    return;
                }

                Store.modals.reportComment.show = true;
                Store.modals.reportComment.comment = this.list;
            },

            /**
             *  Send comment to CommentForm to be replied to.
             *
             * @return void
             */
            commentReply() {
                if (this.isGuest) {
                    this.mustBeLogin();
                    return;
                }
                this.reply = !this.reply;

                this.$eventHub.$emit("reply-comment", this.list);
            },

            bookmark: _.debounce(
                function () {
                    if (this.isGuest) {
                        this.mustBeLogin();
                        return;
                    }

                    this.bookmarked = !this.bookmarked;

                    axios.post(`/comments/${this.list.id}/bookmark`).catch(() => {
                        this.bookmarked = !this.bookmarked;
                    });
                },
                200,
                {leading: true, trailing: false}
            ),

            isDeleted(list) {
                if ((list.is_removed || list.deleted_at) && !this.owns) {
                    if (!!list.deletedAdmin || list.is_removed) {
                        this.deleted = '[Removed]'
                    } else {
                        this.deleted = '[Deleted]'
                    }
                }
            },
            /**
             * Deletes the comment. Only the author is allowed to make such decision.
             *
             * @return void
             */
            destroy() {
                // this.visible = false;

                axios.delete(`/comments/${this.list.id}`)
                    .then((response) => {
                        app.$message({
                            message: response.data.message,
                            type: "success",
                            showClose: true
                        });

                        if (response.data.message == 'Author hidden successfully.') {
                            this.list.deleted_by = true
                        } else {
                            let list = this.list;
                            list.deleted_at = true;
                            if (this.meta.isHumtogAdministrator) {
                                list.deletedAdmin = true
                            }
                            this.isDeleted(list)
                        }
                    })
                // .catch(() => (this.visible = true));
            },

            /**
             * deletes the broadcasted comment
             *
             * @return void
             */
            deletedComment(comment) {
                if (comment.id != this.list.id) return;
                this.visible = false;
            },

            /**
             * Approves the comment. Only the moderators of channel are allowed to do this.
             *
             * @return void
             */
            approve() {
                axios
                    .post('moderator/comments/'+this.list.id+'/approve')
                    .then((response) => {
                        app.$message({
                            message: response.data.message,
                            type: "success",
                            showClose: true
                        });
                    });
            },

            /**
             * Disapproves the comment. Only the moderators of channel are allowed to do this.
             *
             * @return void
             */
            disapprove() {
                axios.post('moderator/comments/'+this.list.id+'/disapprove')
                    .then((response) => {
                        app.$message({
                            message: response.data.message,
                            type: "success",
                            showClose: true
                        });
                    })
            },

            changeType() {
                axios
                    .post(`/comments/${this.list.id}/change-type`)
                    .then((response) => {
                        app.$message({
                            message: response.data.message,
                            type: "success",
                            showClose: true
                        });
                        this.list.type = this.list.type == 'serious' ? 'relaxed' : 'serious'
                        this.$eventHub.$emit('reRender');
                    })
                    .catch(() => (this.list.approved_at = null));
            }
        }
    };
</script>

<style lang="scss">
    .comment {


        .v-comment-info {
            display: flex;
            justify-content: space-between;
        }

        .left {
            display: flex;
            align-items: center;
            word-break: normal;
        }

        .actions-right {
            display: flex;
        }

        .separator {
            margin-left: 0.5em;
            margin-right: 0.5em;
            color: #979797;
            font-weight: bold;
        }

        .date {
            color: #979797;
            font-size: 70%;
            cursor: pointer;
            vertical-align: super;
            &:hover {
                text-decoration: underline;
            }
        }

        .like-button {
            display: inline-flex;
            align-items: center;
            cursor: pointer;

            .count {
                font-weight: bold;
                font-size: 80%;
                color: #979797;
                margin-right: 1em;
            }

            &:hover {
                i {
                    color: #db6e6e !important;
                }

                .count {
                    color: #db6e6e;
                }
            }
        }

        .v-bookmark:hover {
            color: #edb431;
        }

        .v-reply:hover {
            color: #78b38a;
        }

        .el-badge {
            position: relative;
            vertical-align: middle;
            display: inline-block;
            margin-left: -9px;
            margin-top: 4px;
        }

        .el-icon-more-outline:hover {
            color: #000;
        }

        .glyphicon {
            opacity: 1;
            transition: opacity 0.25s ease-in-out;
            -moz-transition: opacity 0.25s ease-in-out;
            -webkit-transition: opacity 0.25s ease-in-out;
        }

        .glyphicon:hover {
            opacity: 0.75;
            cursor: pointer;
        }


        .comments-deleted-show {
            background: #995454;
            padding: 1px;
        }

        .comments-deleted-hide {
            padding: 2px;
        }
    }

    .replycomment {
        color: #979797;
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
    }

    #textarea-remove-comment {
        margin-top: 10px;
        width: 100%;
        height: 50px;
        border-radius: 5px;
        border: 1px solid #c2c2c2;
    }
    @media (max-width: 600px) {
        .comment .authorname {
            font-size: 11px!important;
        }
        .comment .author {
            font-size: 11px!important;
        }
        .comment .date {
            font-size: 11px!important;
        }
        .comment {
            padding: 0;
        }
        .comment .avatar {
            width: 1.2em;
        }
        .v-bookmark {
            display: none;
        }

    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Comment.vue